import webWorksData from 'data/webWorksData';
import React from 'react';
import WorksSlider from './WorksSlider';

export default function WebWorks () {
    return (
        <div className="my-5">
            <h4 className="text-center">Web Applications</h4>
            <WorksSlider data={webWorksData}></WorksSlider>
        </div>
    );
};